export default{
    async getLogList({ commit }, searchParam){
        let sort = [];
        for (let i = 0; i < searchParam.options.sortBy.length; i++) {
            sort[i] = {
                key: searchParam.options.sortBy[i],
                asc: !searchParam.options.sortDesc[i]
            };
        }
        let searchData = {
            page: searchParam.options.page,
            per_page: searchParam.options.itemsPerPage,
            sort: sort,
            search: { ...searchParam.searchKeys },
            aggregate_day_range: searchParam.aggregate_day_range
        }
        commit('setSearchingData', searchData, {root: false});
        return await this.$axios.$post(
            this.$api.tenantAdmin.logview.list,
            searchData
        )
    },

    async getCategoryList(){
        return await this.$axios.$get(
            this.$api.tenantAdmin.logview.getCategoryList
        )
    },

    async downloadCsvLogList({}, range){
        return this.$downloader.downloadPost(this.$axios, this.$api.tenantAdmin.logview.downloadCsvLogList, range)
        .catch(error => {
        });
    },
}